import * as React from "react"

const SvgArrowDown = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M13.006 16.465V5.286a.97.97 0 0 0-.287-.713.97.97 0 0 0-.713-.287.97.97 0 0 0-.712.287.97.97 0 0 0-.287.713v11.179l-4.9-4.902a.92.92 0 0 0-.7-.288q-.4.013-.7.313-.273.3-.287.7-.012.4.288.7l6.599 6.603q.15.15.325.212.174.063.374.063.201 0 .375-.063a.9.9 0 0 0 .325-.212l6.599-6.603a.93.93 0 0 0 .275-.687 1.02 1.02 0 0 0-.275-.713q-.3-.3-.712-.3-.413 0-.713.3z" />
  </svg>
)
export default SvgArrowDown
